import './PageNotFound.scss'

function App() {
  return (
    <div className="App">
      <p>Page not found</p>
    </div>
  )
}

export default App
